export default {
  triggers: state => {
    return state.triggers;
  },
  triggerById: state => id => {
    const filtered = state.triggers.filter(item => {
      return parseInt(item.id) === parseInt(id);
    });

    return typeof filtered[0] !== 'undefined' ? filtered[0] : null;
  }
};